import { render } from "./CreationSkill.vue?vue&type=template&id=c73233d6&scoped=true"
import script from "./CreationSkill.vue?vue&type=script&lang=js"
export * from "./CreationSkill.vue?vue&type=script&lang=js"

import "./CreationSkill.vue?vue&type=style&index=0&id=c73233d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c73233d6"]])

export default __exports__